// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.escher-container .settingsBackground {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba(0,0,0,.4);
  padding: 5% 0 80px;
  text-align: center;
}

.escher-container .scale-editor .domain-input {
  color: #333;
}

.escher-container .settingsBoxContainer button {
  position: absolute;
  top: 5px;
  right: 20px;
  z-index: 10;
  text-align: center;
  vertical-align: middle;
  font-weight: normal!important;
  width: 34px;
  height: 30px;
  margin: 0;
  padding: unset;
  font-size: 14px!important;
  border-radius: 3px;
  -ms-touch-action: none;
  touch-action: none;
}

.escher-container .settingsBoxContainer button:active {
  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);
}

.escher-container .settingsBoxContainer .discardChanges {
  right: 60px;
}

.escher-container .settingsBoxContainer {
  color: rgb(119, 119, 119);
  display: inline-block;
  position: relative;
  width: 90%;
  max-width: 520px;
  height: 100%;
  z-index: 10;
}

.escher-container .settingsBox {
  font-size: 13px;
  box-sizing: border-box;
  display: inline-block;
  max-height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  background: rgba(255, 255, 255, 0.953);
  padding: 8px;
  margin: 0;
  border: 1px solid #ddd;
  text-align: left;
}

.escher-container .settingsBox * {
  box-sizing: border-box;
}

.escher-container .settingsBox .title {
  font-size: 17px;
  font-weight: 700;
  color: #777777;
}

.escher-container .settingsBox .subheading {
  font-size: 13px;
  font-weight: 700;
  margin-top: 15px;
  color: #777777;
}

.escher-container .settingsBox table {
  border-collapse: collapse;
}

.escher-container .settingsBox label {
  display: inline;
}

.escher-container .settingsBox .radioSelection {
  cursor: default;
}

.escher-container .radioSelection td {
  padding: 3px 5px;
}

.escher-container .radioSelection input[type=radio] {
  margin: 0;
  margin-top: 4px;
  margin-right: 4px;
}

.escher-container .radioSelection .optionLabel {
  width: 88px;
}

.escher-container .radioSelection .optionLabelWide {
  width: 192px;
}

.escher-container .radioSelection .optionGroup {
  margin-right: 10px
}

.escher-container .settingsBox .singleLine {
  display: flex;
}

.escher-container .settingsContainer label {
  display: block;
  margin-bottom: 0;
}

.escher-container .settingsBoxContainer input[type=checkbox] {
  margin: 0;
  margin-top: 4px;
  margin-right: 4px;
}

.escher-container .settingsTip {
  font-size: 13px;
}

.escher-container .settingsBoxContainer hr {
  margin: 18px 0;
  border: 0;
  border-top: 1px solid #dddddd;
}

.escher-container .scaleTitle {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
}

.escher-container .selector {
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  padding-top: 2px;
}

.escher-container .selectorTitle {
  background-color: white;
  border: 1px solid #a9a9a9;
  padding-left: 4px;
  cursor: default;
  width: 162px;
}

.escher-container .selectorTitle:hover:not(.disabled) {
  border-color: black;
}

.escher-container .selectorTitle.disabled {
  background-color: #f1ecfa;
}

.escher-container .selectorMenu {
  position: absolute;
  z-index: 4;
  background-color: white;
  border: 1px solid #a9a9a9;
  min-width: 162px;
}

.escher-container .scaleSelection {
  cursor: default;
  padding: 0 6px;
  display: flex;
  justify-content: space-between;
}

.escher-container .scaleSelection:hover {
  background-color: dodgerblue;
  color: white;
}

.escher-container .settingsBox .icon-sort-down {
  position: absolute;
  top: 0;
}

.escher-container .settingsBox .tooltipOption {
  margin-left: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/SettingsMenu.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,SAAS;EACT,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".escher-container .settingsBackground {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9;\n  background: rgba(0,0,0,.4);\n  padding: 5% 0 80px;\n  text-align: center;\n}\n\n.escher-container .scale-editor .domain-input {\n  color: #333;\n}\n\n.escher-container .settingsBoxContainer button {\n  position: absolute;\n  top: 5px;\n  right: 20px;\n  z-index: 10;\n  text-align: center;\n  vertical-align: middle;\n  font-weight: normal!important;\n  width: 34px;\n  height: 30px;\n  margin: 0;\n  padding: unset;\n  font-size: 14px!important;\n  border-radius: 3px;\n  -ms-touch-action: none;\n  touch-action: none;\n}\n\n.escher-container .settingsBoxContainer button:active {\n  background-image: linear-gradient(#3F4141, #474949 6%, #4F5151);\n}\n\n.escher-container .settingsBoxContainer .discardChanges {\n  right: 60px;\n}\n\n.escher-container .settingsBoxContainer {\n  color: rgb(119, 119, 119);\n  display: inline-block;\n  position: relative;\n  width: 90%;\n  max-width: 520px;\n  height: 100%;\n  z-index: 10;\n}\n\n.escher-container .settingsBox {\n  font-size: 13px;\n  box-sizing: border-box;\n  display: inline-block;\n  max-height: 100%;\n  width: 100%;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  background: rgba(255, 255, 255, 0.953);\n  padding: 8px;\n  margin: 0;\n  border: 1px solid #ddd;\n  text-align: left;\n}\n\n.escher-container .settingsBox * {\n  box-sizing: border-box;\n}\n\n.escher-container .settingsBox .title {\n  font-size: 17px;\n  font-weight: 700;\n  color: #777777;\n}\n\n.escher-container .settingsBox .subheading {\n  font-size: 13px;\n  font-weight: 700;\n  margin-top: 15px;\n  color: #777777;\n}\n\n.escher-container .settingsBox table {\n  border-collapse: collapse;\n}\n\n.escher-container .settingsBox label {\n  display: inline;\n}\n\n.escher-container .settingsBox .radioSelection {\n  cursor: default;\n}\n\n.escher-container .radioSelection td {\n  padding: 3px 5px;\n}\n\n.escher-container .radioSelection input[type=radio] {\n  margin: 0;\n  margin-top: 4px;\n  margin-right: 4px;\n}\n\n.escher-container .radioSelection .optionLabel {\n  width: 88px;\n}\n\n.escher-container .radioSelection .optionLabelWide {\n  width: 192px;\n}\n\n.escher-container .radioSelection .optionGroup {\n  margin-right: 10px\n}\n\n.escher-container .settingsBox .singleLine {\n  display: flex;\n}\n\n.escher-container .settingsContainer label {\n  display: block;\n  margin-bottom: 0;\n}\n\n.escher-container .settingsBoxContainer input[type=checkbox] {\n  margin: 0;\n  margin-top: 4px;\n  margin-right: 4px;\n}\n\n.escher-container .settingsTip {\n  font-size: 13px;\n}\n\n.escher-container .settingsBoxContainer hr {\n  margin: 18px 0;\n  border: 0;\n  border-top: 1px solid #dddddd;\n}\n\n.escher-container .scaleTitle {\n  margin-top: 15px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.escher-container .selector {\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  padding-top: 2px;\n}\n\n.escher-container .selectorTitle {\n  background-color: white;\n  border: 1px solid #a9a9a9;\n  padding-left: 4px;\n  cursor: default;\n  width: 162px;\n}\n\n.escher-container .selectorTitle:hover:not(.disabled) {\n  border-color: black;\n}\n\n.escher-container .selectorTitle.disabled {\n  background-color: #f1ecfa;\n}\n\n.escher-container .selectorMenu {\n  position: absolute;\n  z-index: 4;\n  background-color: white;\n  border: 1px solid #a9a9a9;\n  min-width: 162px;\n}\n\n.escher-container .scaleSelection {\n  cursor: default;\n  padding: 0 6px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.escher-container .scaleSelection:hover {\n  background-color: dodgerblue;\n  color: white;\n}\n\n.escher-container .settingsBox .icon-sort-down {\n  position: absolute;\n  top: 0;\n}\n\n.escher-container .settingsBox .tooltipOption {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
